import React, { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import './styles.scss'
import Table from '../../../Shared/Table'
import TableHead from '../../../Shared/Table/TableHead'
import TableRow from '../../../Shared/Table/TableRow'
import TableRowGroup from '../../../Shared/Table/TableRowGroup'
import CollapsibleTrigger from '../../../Shared/Collapsible/CollapsibleTrigger'
import { getCountries, getSuppliers } from '../../../../http/driveApiGateway/client'
import Row from '../../../Shared/GridGM'
import Col from '../../../Shared/GridGM/Col'
import PropTypes from 'prop-types'
import TableData from '../../../Shared/Table/TableData'
import Stars from '../../../Shared/Stars'
import Alert from '../../../Shared/Alert'
import GreyMainHotel from '../../../Shared/Hotel/GreyMainHotel'
import { Container } from '../../../Shared/Grid'
import PageHead from '../../../Shared/PageHead'
import { constants } from '../../../../constants'

const SalesChannels = ({ giataId, item, relatedItems, propertyImage }) => {
  const [suppliers, setSuppliers] = useState({
    suppliers: [],
    suppliersCount: 0,
    recordsCount: 0,
  })
  const [countries, setCountries] = useState({ codes: {} })
  const [error, setError] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
      const fetchData = () => {
        setError(false)
        getSuppliers(giataId).fetchPromise
          .then((suppliersData) => {
            setSuppliers(suppliersData)
          })
          .catch((e) => {
            setError(true)
            console.error(e)
          })
        getCountries().fetchPromise
          .then((countriesData) => {
            setCountries(countriesData)
          })
          .catch((e) => {
            setError(true)
            console.error(e)
          })
      }
      fetchData()
    }, [giataId]
  )

  const renderSupplierRecords = (supplier, index) => {
    return supplier.records.map((record) => (
      <TableRow className={`record record_${index}`} key={record.hotelcode}>
        <TableData>{record.hotelcode}</TableData>
        <TableData>{record.hotelname}</TableData>
        <TableData>
          <Stars count={record.rating}/>
        </TableData>
        <TableData>{record.city}</TableData>
        <TableData>
          {countries &&
          record.country.code !== undefined &&
          countries.codes[record.country.code] !== undefined ? (
            countries.codes[record.country.code].name
          ) : (
            'N/A'
          )}
        </TableData>
        <TableData/>
      </TableRow>
    ))
  }

  return (
    <div className="Page page-sales-channels">
      <div className="Distribution">
        {error ? (
          <Alert type="danger">{t('DEFAULT_ERROR_MESSAGE')}</Alert>
        ) : (
          <React.Fragment>
            <Container fluid>
              <Row>
                <Col>
                  <PageHead
                    title={t('SALES_CHANNELS')}
                    subtitle="This page shows a list of channels that sell your property, along with the basic info they use."
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <span style={{ lineHeight: '37px' }}>
                    The list is compiled using data from GIATA mapping partners and does not indicate that your Drive content will be distributed to these channels.
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={{ marginTop: '50px', marginBottom: '16px' }}>
                    <GreyMainHotel
                      item={item}
                      relatedItems={relatedItems}
                      tourOperatorsCount={10}
                      offersCount={10}
                      propertyImage={propertyImage}
                      infoValues={[
                        {
                          header: 'GIATA ID',
                          value: item.attr[constants.attributePaths.giataId][1].data.code,
                        },
                        {
                          header: t('LABEL_SUPPLIERS'),
                          value: suppliers.suppliersCount,
                        },
                        {
                          header: t('LABEL_RECORDS'),
                          value: suppliers.recordsCount,
                        },
                      ]}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
            <div className="container" style={{ padding: 0 }}>
              <CollapsibleTrigger
                className="CollapseAll"
                for="record"
                openText={t('COLLAPSIBLE_OPEN_ALL')}
              >
                <Trans>COLLAPSIBLE_CLOSE_ALL</Trans>
              </CollapsibleTrigger>
              <Table className="TableDistribution">
                <TableRow>
                  <TableHead>
                    <Trans>TABLE_HEAD_PRODUCT_CODE</Trans>
                  </TableHead>
                  <TableHead>
                    <Trans>TABLE_HEAD_HOTEL_NAME</Trans>
                  </TableHead>
                  <TableHead>
                    <Trans>TABLE_HEAD_CATEGORY</Trans>
                  </TableHead>
                  <TableHead>
                    <Trans>TABLE_HEAD_CITY</Trans>
                  </TableHead>
                  <TableHead width="100">
                    <Trans>TABLE_HEAD_COUNTRY</Trans>
                  </TableHead>
                  <TableHead width="1"/>
                </TableRow>

                {suppliers.suppliers.map((supplier, index) => (
                  <TableRowGroup key={index}>
                    <TableRow className="SubHead">
                      <TableHead>
                        <h4>
                          <CollapsibleTrigger for={`record_${index}`}>{supplier.name}</CollapsibleTrigger>
                        </h4>
                      </TableHead>
                      <TableHead/>
                      <TableHead/>
                      <TableHead/>
                      <TableHead>
                        <Trans>TABLE_HEAD_TOTAL_OFFERS</Trans>: {supplier.records.length}
                      </TableHead>
                      <TableHead>
                        <CollapsibleTrigger for={`record_${index}`}/>
                      </TableHead>
                    </TableRow>
                    {renderSupplierRecords(supplier, index)}
                  </TableRowGroup>
                ))}
              </Table>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

SalesChannels.propTypes = {
  giataId: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  relatedItems: PropTypes.array.isRequired,
  propertyImage: PropTypes.string,
}

export default SalesChannels
